module.exports = __webpack_public_path__ + "static/media/cover-physical-security-systems.086c3c87.jpg";